import { render, staticRenderFns } from "./cc-auth.vue?vue&type=template&id=35677dcd&"
import script from "./cc-auth.vue?vue&type=script&lang=js&"
export * from "./cc-auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports